import React, { Suspense, Fragment } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Loader from "../Layout/Loader";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";
import { authRoutes } from "./AuthRoutes";
import SignIn from "../Auth/Signin";
import ForgotPassword from "../Auth/ForgotPassword";
import ResetPassword from "../Auth/ResetPassword";
import MagicLinkVerify from "../Auth/MagicLinkVerify";
import Wholesale from "../Components/App/Ecommerce/WholesaleOrderForm";
const Routers = () => {
  return (
    <Fragment>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/login" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/magic-link" element={<MagicLinkVerify />} />
            <Route path="/collection-order-form/:id" element={<Wholesale />} />
            <Route path="/faraadmin/collection-order-form/:id" element={<Wholesale />} />
            {authRoutes.map(({ path, Component }, i) => (
              <Route path={path} element={Component} key={i} />
            ))}
            <Route path={"/"} element={<PrivateRoute />}>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            {/* The dashboard used to live at /dashboard/default; keep old bookmarks working. */}
            <Route path="/dashboard/default" element={<Navigate to="/dashboard" replace />} />
            <Route path="/*" element={<LayoutRoutes />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};
export default Routers;
